export interface ShortTestimonial {
  initials: string
  name: string
  place: string
  quote: string
}

export const shortTestimonials: ShortTestimonial[] = [
  {
    initials: 'LM',
    name: 'Lucía M.',
    place: 'Buenos Aires',
    quote:
      'Tenía audios, capturas y mensajes guardados sin saber qué hacer. Ahora tengo un lugar único donde coloco todo y manejo mi tiempo sin saturarme.',
  },
  {
    initials: 'VR',
    name: 'Valentina R.',
    place: 'Córdoba',
    quote:
      'Los últimos meses fue caos. Entré en pánico cada vez que recibía un audio. Con el sistema respiro de nuevo.',
  },
  {
    initials: 'SD',
    name: 'Sofía D.',
    place: 'La Plata',
    quote:
      'Dejé de sentirme culpable por no revisar todo en el momento. Ahora capturo y organizo cuando puedo, sin presión.',
  },
]

export interface LongTestimonial {
  name: string
  place: string
  quote: string
}

export const longTestimonials: LongTestimonial[] = [
  {
    name: 'Catalina H.',
    place: 'Buenos Aires',
    quote:
      '“Tenía todo en la cabeza. Ahora tengo un sistema donde coloco la información y duermo tranquila.”',
  },
  {
    name: 'Romina P.',
    place: 'Rosario',
    quote:
      '“Los audios de mi mamá, los videos que encuentro, los artículos… todo iba a parar al mismo lugar. Ahora tengo orden y dejo de sentirme en deuda.”',
  },
  {
    name: 'Alejandra S.',
    place: 'Mendoza',
    quote:
      '“No es que sepa más de epilepsia. Es que controlo mejor la información que recibo. Eso cambió todo.”',
  },
  {
    name: 'Belén T.',
    place: 'La Plata',
    quote:
      '“Mi teléfono dejó de estar lleno de screenshots sin procesar. Ahora sé dónde está cada cosa.”',
  },
]

export const purchases: Array<[string, string]> = [
  ['Lucía M.', 'Buenos Aires'],
  ['Valentina R.', 'Córdoba'],
  ['Sofía D.', 'La Plata'],
  ['Romina P.', 'Rosario'],
]
